<app-card-content [headerColor]="false" icon="pi pi-book" title="Anotações">
    <app-custom-table [data]="anotacoes()" [metadata]="tableMetadata" [loading]="loading()" [permissaoUf]="pessoa()?.uf ?? null" />
    @if (loading()) {
        <div class="mt-2">Carregando anotações...</div>
    }
    @if (!loading() && erro()) {
        <div class="mt-2 text-red-500">{{ erro() }}</div>
    }
</app-card-content>

<app-anotacao-nova [showDialog]="modalNovaAnotacao()" (showDialogChange)="modalNovaAnotacao.set($event)" [pessoa]="pessoa()" [salvando]="loading()" (anotacaoCriada)="onAnotacaoCriada($event)" />
